import { createContext, useContext } from "react";
import { GlobalFilters } from "./types";

export const GlobalFiltersContext = createContext<GlobalFilters | undefined>(
  undefined,
);

export const useGlobalFiltersContext = (): GlobalFilters => {
  const context = useContext(GlobalFiltersContext);

  if (!context) {
    throw new Error(
      "useGlobalFilters must be used within a GlobalFiltersProvider",
    );
  }

  return context;
};
